import { CartInterface, CheckoutInterface } from "@/types/cart";

export interface CheckoutSettings {
  shippingValue: number;
  minOrderValue: number;
}

const calculateTotalPrice = (items: CartInterface[]) =>
  items.reduce((acc, { quantity, price }) => acc + quantity * price, 0);

const calculateTotalDiscount = (items: CartInterface[]) =>
  items.reduce(
    (acc, { quantity, flatDiscount }) =>
      acc + quantity * (flatDiscount || 0),
    0,
  );

const calculateProductShipping = (items: CartInterface[]) =>
  items.reduce(
    (acc, { quantity, shippingFee }) => acc + quantity * (shippingFee ?? 0),
    0,
  );

export const getCheckoutFromItems = (
  items: CartInterface[],
  { shippingValue, minOrderValue }: CheckoutSettings,
): CheckoutInterface => {
  const price = calculateTotalPrice(items);
  const discountPrice = calculateTotalDiscount(items);
  const subtotalAfterDiscount = price - discountPrice;
  const productShipping = calculateProductShipping(items);
  const shipping =
    subtotalAfterDiscount < minOrderValue
      ? shippingValue + productShipping
      : productShipping;

  return {
    price,
    discountPrice,
    shipping,
    total: subtotalAfterDiscount + shipping,
  };
};

export const getFreeShippingMessage = (
  subtotalAfterDiscount: number,
  minOrderValue: number,
): string | undefined => {
  if (minOrderValue <= 0 || subtotalAfterDiscount >= minOrderValue) {
    return undefined;
  }
  const needed = minOrderValue - subtotalAfterDiscount;
  return `Add $${needed.toFixed(2)} more for free shipping`;
};
